let c1009 = document.querySelector('.C1009');

(function loadAll() {
    let button = c1009.querySelector("button");
    if (!button) return;
    let hidden = c1009.querySelectorAll('.hidden');

    button.addEventListener('click', () => {
        hidden.forEach((e) => {
            e.classList.remove('hidden');
            e.classList.add('animate-scale');
        })
        button.nextSibling.remove();
        button.remove();
    })
})();

let li = c1009.querySelectorAll('li');

createMasonryLayout();

function createMasonryLayout() {
    let row = c1009.querySelector('.row');
    let ul = row.querySelectorAll('ul');

    ul.forEach((ul)=> {
        ul.remove();
    })

    let colsCount = 1;
    let sidebarTemplate = document.querySelector('.sidebar-template')

    let md = window.matchMedia("(min-width: 768px)")
    if (md.matches) colsCount = 2;
    
    let lg = window.matchMedia("(min-width: 1024px)")
    if (lg.matches && !sidebarTemplate) colsCount = 3;
    
    for (let i = 1; i <= colsCount; i++) {
        let col = document.createElement('ul');
        col.classList.add('col','flex', 'flex-col','gap-y-6', 'w-full');
        row.appendChild(col);
    }

    let cols = c1009.querySelectorAll('.col');
    let index = 0;

    for (let i = 0; i < li.length; i++) {

        cols[index++].appendChild(li[i]);

        if (index === colsCount) {
            index = 0;
        }
    }
};

let windowWidth = window.innerWidth;

window.addEventListener('resize', ()=> {
    if (window.innerWidth != windowWidth) {
        windowWidth = window.innerWidth;
        createMasonryLayout();
    }
});

